import { pxToRem } from '../../../../lib';
export default (function (siteVars) {
  return {
    borderRadius: siteVars.borderRadius,
    backgroundColorFocus: siteVars.colors.grey[200],
    boxShadow: siteVars.shadowLevel1,
    borderColor: siteVars.colors.grey[200],
    colorFocus: siteVars.colors.grey[750],
    primaryBackgroundColorFocus: siteVars.colors.brand[800],
    primaryColorFocus: siteVars.colors.white,
    padding: "0 ".concat(pxToRem(16)),
    iconMargin: "0 0 ".concat(pxToRem(8), " 0")
  };
});